import { isAxiosError } from 'axios';

export default function getApiErrorCode(error: unknown) {
  if (isAxiosError(error)) {
    return error.response?.data?.errorCode || 'An unknown error occurred';
  }

  return 'An unknown error occurred';
}
